document.addEventListener("DOMContentLoaded", () => {
    let lastScrollTop = 0; // To track the last scroll position

    // Add scroll event listener
    window.addEventListener("scroll", () => {
        const evenBoxes = document.querySelectorAll(".even-box");
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Determine scroll direction
        const scrollDirection = currentScrollTop > lastScrollTop ? "down" : "up";

        // Apply transform based on scroll direction
        evenBoxes.forEach((box) => {
            if (scrollDirection === "up") {
                box.style.transform = "translateY(-20px)";
            } else {
                box.style.transform = "translateY(20px)";
            }
        });

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Prevent negative values
    });
});
